import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TravelServicePage.css';

const TravelServicePage = ({ config }) => {
  const navigate = useNavigate();

  if (!config) {
    return null;
  }

  const {
    name,
    tagline,
    description,
    heroImage,
    accent,
    metrics,
    highlights,
    journey,
    testimonials,
    cta
  } = config;

  return (
    <div className="travel-service-page" style={{ '--accent-color': accent }}>
      <section className="service-hero">
        <div className="service-hero-media">
          <img src={heroImage} alt={`${name} hero`} />
        </div>
        <div className="service-hero-content container">
          <div className="service-pill">InnBotics • {name}</div>
          <h1>{tagline}</h1>
          <p>{description}</p>
          <div className="service-metrics">
            {metrics.map((metric, idx) => (
              <div key={idx} className="service-metric">
                <h3>{metric.value}</h3>
                <p>{metric.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-highlights">
        <div className="container">
          <h2>Why travellers love our {name.toLowerCase()} suite</h2>
          <div className="highlight-grid">
            {highlights.map((item, idx) => (
              <article key={idx} className="highlight-card">
                <div className="highlight-icon" aria-hidden="true">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="service-journey">
        <div className="container">
          <div className="journey-header">
            <h2>Plan the seamless way</h2>
            <p>InnBotics connects every step so your {name.toLowerCase()} experience flows effortlessly.</p>
          </div>
          <div className="journey-timeline">
            {journey.map((step, idx) => (
              <div key={idx} className="journey-step">
                <div className="step-index">{String(idx + 1).padStart(2, '0')}</div>
                <div className="step-content">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                  {step.link && (
                    <button type="button" className="step-link" onClick={() => navigate(step.link.href)}>
                      {step.link.label}
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-testimonials">
        <div className="container">
          <div className="testimonial-header">
            <h2>Trusted by modern explorers</h2>
            <p>From solo travelers to operations teams, we deliver plans that actually work.</p>
          </div>
          <div className="testimonial-grid">
            {testimonials.map((item, idx) => (
              <blockquote key={idx} className="testimonial-card">
                <p>“{item.quote}”</p>
                <footer>
                  <span className="testimonial-name">{item.name}</span>
                  <span className="testimonial-role">{item.role}</span>
                </footer>
              </blockquote>
            ))}
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <div className="cta-content">
            <h2>{cta.title}</h2>
            <p>{cta.description}</p>
          </div>
          <div className="cta-actions">
            {cta.actions.map((action, idx) => (
              <button
                key={idx}
                type="button"
                className={action.primary ? 'primary-btn' : 'ghost-btn'}
                onClick={() => navigate(action.href)}
              >
                {action.label}
              </button>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TravelServicePage;
